import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../../assets/css/Customermodalbox.css';
import SelectCustomer from './SelectCustomer';

function CustomerModalbox() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleExternalRedirect = () => {
  window.location.href = '/summary';
   };

  return (
    <>
     <Button className="btn btnprimary mb-1" onClick={handleShow}>  Envogue customer test  -Delhi </Button> 

     <div className='bodymodalbox'> 
      <Modal show={show} onHide={handleClose}>
        <Modal.Body> 
          <SelectCustomer/>
             <p className='mb-3 text-sm'>  do you want to continue this customer or change ? </p>
               <div className=' d-flex justify-content-end'> 
               <Button className='btn btn-light btn-outline-dark btn-small' onClick={handleClose}>
                Change
               </Button>
               <Button className='savebtn btn-small'   onClick={handleExternalRedirect} style={{ backgroundColor: "#ff935c", color:"rgb(51 48 48)" }}>
                Proceed
              </Button>
            </div>
           </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
export default CustomerModalbox;


